/**
 * Version checker utility to detect new application versions
 */

let currentVersion = null;

/**
 * Check for new application version by comparing version.json
 * @param {Function} onUpdateAvailable Callback when update is available
 * @param {number} intervalMinutes How often to check for updates (in minutes)
 */
export const startVersionChecker = (onUpdateAvailable, intervalMinutes = 0.16) => {
  // Initial check
  checkVersion(onUpdateAvailable);
  
  // Set up regular checks
  setInterval(() => {
    checkVersion(onUpdateAvailable);
  }, intervalMinutes * 60 * 1000);
};

/**
 * Fetch version.json and compare with current version
 */
const checkVersion = (onUpdateAvailable) => {
  fetch('/version.json?' + new Date().getTime())
    .then(response => response.json())
    .then(data => {
      // First load, just save the current version
      if (currentVersion === null) {
        currentVersion = data.version;
        return;
      }
      
      // If version changed, notify via callback
      if (data.version !== currentVersion) {
        onUpdateAvailable(data.version);
      }
    })
    .catch(error => {
      console.error('Error checking for app updates:', error);
    });
};

export const getCurrentVersion = () => {
    return currentVersion || '1.0.0';
}; 